var map = {
	"./menuIcon_1.png": 71286,
	"./menuIcon_2.png": 49684,
	"./menuIcon_3.png": 30222,
	"./menuIcon_4.png": 66129,
	"./menuIcon_5.png": 67526,
	"./menuIcon_6.png": 74885,
	"./menuIcon_7.png": 71948,
	"./menuIcon_8.png": 63674,
	"./menuIcon_9.png": 88813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96346;